import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import edit from '../../../assets/icons/new_icon/edit-white.svg';
import { AbilityContext } from '../../../context/AbilityContext';
import { useShipForm } from '../../../context/shipForms';
import { AddressDto, ContactDto } from '../../../types';
import ShipmentATALegsTable from '../../global-components/shipment-legs-tables/shipmentATALegsTable';
import PackageFields from './packageFeilds';
import ReferenceFields from './referenceFields';
import SpecialInstructionsFields from './specialInstructions';
import SummaryAddressContactFields from './summaryAddressContactField';
import UploadDocField from './uploadDocFields';

interface Props {
  setShowSummary: any;
  setShowPayment: any;
  setCurrentShipmentStatus: any;
  setEditRouteForm: any;
  setEditPackageForm: any;
  setShowRates?: any;
  setShowPickup?: any;
  setShowRoutes?: any;
}
function SummaryForm({
  setShowPayment,
  setShowSummary,
  setCurrentShipmentStatus,
  setEditRouteForm,
  setEditPackageForm,
  setShowRates,
  setShowPickup,
  setShowRoutes,
}: Props) {
  const {
    getRatesApiPayloadContext,
    getOriginFormData,
    getShipperFormData,
    getDestinationFormData,
    getConsigneeFormData,
    getShippingDocsContext,
    setShippingDocsContext,
    getSelectedRateContext,
    getFinalRateContext,
    getSelectedATALegsInfo,
    getAddLegShipmentPackagesContext,
  } = useShipForm();
  const location = useLocation();
  const ability = useContext(AbilityContext);
  const isAddLeg = location?.pathname === '/app/add-leg';
  const originFormContextData: AddressDto = getOriginFormData();
  const shipperFormContextData: ContactDto = getShipperFormData();
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const ConsigneeFormContextData: ContactDto = getConsigneeFormData();
  const ratesPayloadData: any = getRatesApiPayloadContext();
  const finalRatesContextData: any = getFinalRateContext();
  const shippingDocsContext: any = getShippingDocsContext();
  const selectedRateContext: any = getSelectedRateContext();
  const selectedATALegsInfoContext: any = getSelectedATALegsInfo();
  const addLegShipmentPackagesContext: any = getAddLegShipmentPackagesContext();

  const [isPriceHidden, setIsPriceHidden] = useState<any>(
    !ability?.can('read', 'View Price')
  );
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([0]);
  const [documents, setDocuments] = useState<any>(
    shippingDocsContext ? shippingDocsContext : []
  );
  function backRoute() {
    if (
      selectedRateContext?.main?.type_code !== 'ATA' ||
      selectedRateContext?.pickup !== undefined
    ) {
      setShowSummary(false);
      setShowRates && setShowRates(true);
      setCurrentShipmentStatus('pickup');
    } else {
      setShowSummary(false);
      setCurrentShipmentStatus('pickup');
    }
    setShippingDocsContext(documents);
  }
  function nextSummary() {
    setShippingDocsContext(documents);
    window?.scrollTo(0, 0);
    setShowPayment(true);
    setCurrentShipmentStatus('payment');
  }
  const { getPickupPayloadContext, getMultiLegListContext, getTotalLegs } =
    useShipForm();
  const pickupPayloadContext: any = getPickupPayloadContext();
  const mltiLegListContext: any = getMultiLegListContext();
  const totalLegContext: any = getTotalLegs();
  const handleLegSummaryAccordionToggle = (index: number) => {
    const currentIndex = expandedIndexes.indexOf(index);
    const newIndexes = [...expandedIndexes];
    if (currentIndex === -1) {
      newIndexes.push(index);
    } else {
      newIndexes.splice(currentIndex, 1);
    }
    setExpandedIndexes(newIndexes);
  };
  const handleEditNavigation = () => {
    setShowSummary(false);
    setShowPickup(false);
    setShowRates(false);
    setShowRoutes(true);
    setCurrentShipmentStatus('routes');
  };
  return (
    <div id='summary_section'>
      {isAddLeg && (
        <>
          {mltiLegListContext &&
            mltiLegListContext.map((data: any, index: any) => {
              return (
                <div
                  key={index}
                  className='accordion accordion-flush mt-3'
                  style={{ backgroundColor: 'transparent' }}
                  id={`shipment_document_accordion_${index}`}
                >
                  {' '}
                  <div
                    className='accordion-item border'
                    style={{ backgroundColor: 'white' }}
                  >
                    <h2
                      className='accordion-header'
                      id='main_document_head'
                    >
                      <div className='row'>
                        <div className='col-12'>
                          <button
                            className={`accordion-button col-12  ${
                              expandedIndexes.includes(index)
                                ? 'active'
                                : 'collapsed'
                            }`}
                            type='button'
                            style={{ backgroundColor: '#251163' }}
                            onClick={() =>
                              handleLegSummaryAccordionToggle(index)
                            }
                          >
                            <h5
                              className='accordion-header boldsteppertext'
                              id='shipment_document_head'
                              style={{ color: 'white' }}
                            >
                              L{totalLegContext + index + 1}
                            </h5>
                          </button>
                        </div>
                      </div>
                    </h2>
                    <div
                      id='main_document_body'
                      className={`accordion-collapse p-4 pb-5 collapse  ${
                        expandedIndexes.includes(index) ? 'show' : ''
                      }`}
                      aria-labelledby={`main_document_head_${index}`}
                      data-bs-parent={`#shipment_document_accordion_${index}`}
                    >
                      <div className='accordion-body p-0 mt-2'>
                        <div className='row '>
                          <div className='col-sm-12 col-md-4 h-auto'>
                            <SummaryAddressContactFields
                              label={'Origin'}
                              setCurrentShipmentStatus={
                                setCurrentShipmentStatus
                              }
                              setEditRouteForm={setEditRouteForm}
                              addressFormData={data && data?.origin}
                              contactFormData={data && data?.shipper}
                              isAddLeg={isAddLeg}
                            />
                          </div>
                          <div className='col-sm-12 col-md-4 h-auto'>
                            <SummaryAddressContactFields
                              label={'Destination'}
                              setCurrentShipmentStatus={
                                setCurrentShipmentStatus
                              }
                              setEditRouteForm={setEditRouteForm}
                              addressFormData={data && data?.destination}
                              contactFormData={data && data?.consignee}
                              isAddLeg={!isAddLeg}
                              handleEdit={handleEditNavigation}
                              setShowRates={setShowRates}
                              setShowSummary={setShowSummary}
                            />
                          </div>
                          <div className='col-sm-12 col-md-4 h-auto'>
                            <SpecialInstructionsFields
                              setCurrentShipmentStatus={
                                setCurrentShipmentStatus
                              }
                              setEditRouteForm={setEditRouteForm}
                              data={data && data?.special_instructions}
                              isAddLeg={isAddLeg}
                              handleEdit={handleEditNavigation}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </>
      )}
      {!isAddLeg && (
        <>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-4 h-auto'>
              <SummaryAddressContactFields
                label={'Origin'}
                setCurrentShipmentStatus={setCurrentShipmentStatus}
                setEditRouteForm={setEditRouteForm}
                addressFormData={originFormContextData}
                contactFormData={shipperFormContextData}
                isAddLeg={isAddLeg}
              />
            </div>
            <div className='col-sm-12 col-md-4 h-auto'>
              <SummaryAddressContactFields
                label={'Destination'}
                setCurrentShipmentStatus={setCurrentShipmentStatus}
                setEditRouteForm={setEditRouteForm}
                addressFormData={destinationFormContextData}
                contactFormData={ConsigneeFormContextData}
              />
            </div>
            <div className='col-sm-12 col-md-4 h-auto'>
              <ReferenceFields
                setCurrentShipmentStatus={setCurrentShipmentStatus}
                setEditRouteForm={setEditRouteForm}
                setShowSummary={setShowSummary}
                backRoute={backRoute}
              />
            </div>
          </div>

          <div className='row mt-4'>
            <div className='col-sm-12 col-md-6 h-auto'>
              <SpecialInstructionsFields
                setCurrentShipmentStatus={setCurrentShipmentStatus}
                setEditRouteForm={setEditRouteForm}
              />
            </div>
            <div className='col-sm-12 col-md-6'>
              <div className='ubbe-card h-100'>
                <div className='ubbe-card-header'>
                  <h5 className='ps-3 mb-0 GlobalBoxHead'>Pickup</h5>
                </div>
                <div className='card-body  pt-2 p-4 h-100'>
                  <div className='row '>
                    <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
                      <label className='global-text-16'>Pickup Date</label>
                    </div>
                    <div
                      className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
                      id='summary_date_time'
                    >
                      {`${
                        pickupPayloadContext && pickupPayloadContext?.date
                          ? pickupPayloadContext?.date
                          : 'N/A'
                      } `}
                    </div>
                  </div>
                  <div className='row  mt-2 '>
                    <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
                      <label id='pickup_date'>
                        <label className='global-text-16'>Window</label>
                      </label>
                    </div>
                    <div className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'>
                      {` ${
                        pickupPayloadContext && pickupPayloadContext?.start_time
                          ? pickupPayloadContext?.start_time
                          : 'N/A'
                      } to ${
                        pickupPayloadContext && pickupPayloadContext?.end_time
                          ? pickupPayloadContext?.end_time
                          : 'N/A'
                      }`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className='ubbe-card h-auto mt-4'>
        <div className='ubbe-card-header  d-flex justify-content-between'>
          <h5 className=' mb-0 GlobalBoxHead ms-3'>Packages</h5>
          {!isAddLeg && (
            <div
              className='my-auto'
              style={{ paddingRight: '20px' }}
            >
              <button
                type='button'
                className='editwhiteBg'
                onClick={() => {
                  setCurrentShipmentStatus('packages');
                  setEditPackageForm(true);
                }}
              >
                <img
                  src={edit}
                  alt={edit}
                />
              </button>
            </div>
          )}
        </div>
        <div className='card-body p-4 h-auto overflow-auto'>
          <PackageFields
            packages={
              isAddLeg
                ? addLegShipmentPackagesContext
                : ratesPayloadData?.packages
            }
          />
        </div>
      </div>
      <div className=''>
        <UploadDocField
          documents={documents}
          setDocuments={setDocuments}
        />
      </div>
      <div>
        <ShipmentATALegsTable
          selectedRates={selectedRateContext}
          selectedLegsInfo={selectedATALegsInfoContext}
          showInsuranceAndDiscount={true}
          isPriceHidden={isPriceHidden}
          discountAmount={
            finalRatesContextData?.savings
              ? finalRatesContextData?.savings
              : 0.0
          }
          insuranceAmount={
            finalRatesContextData?.insurance &&
            finalRatesContextData?.insurance !== ''
              ? finalRatesContextData?.insurance
              : '0.00'
          }
          existingLegs={totalLegContext}
        />
      </div>
      <div className='d-flex my-5 justify-content-between align-items-center'>
        <div className=''>
          <p
            className='btn btn-ubbe-new-back d-flex gap-2'
            onClick={() => {
              backRoute();
            }}
          >
            {' '}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </p>
        </div>
        <div className=''>
          <p
            className='btn btn-ubbe-new-blue'
            onClick={() => {
              nextSummary();
            }}
          >
            Ship
          </p>
        </div>
      </div>
    </div>
  );
}

export default SummaryForm;
